/** @format */
// eslint-disable-next-line boundaries/element-types -- Touch and change -- We shouldn't import from custom-server into features
import { SiteContentMetaDataResponse } from '@toucan/custom-server/services/contentful/queries/meta';

import { ContentfulQueryId } from '@toucan/common/contentful';

import {
    ContentfulQueryVariables,
    useContentful,
} from '@toucan/client/shared/hooks/use-contentful';

import { transformSiteContentMetaData } from '@toucan/client/features/contentful/helpers/adapters/contentful';

type UseContentfulMetaProps = {
    queryId:
        | ContentfulQueryId.SITE_CONTENT_META_DATA
        | ContentfulQueryId.SITE_CONTENT_META_DATA_BY_SITE_SECTION;
    variables: ContentfulQueryVariables;
    options?: {
        // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
        enabled?: boolean;
    };
};

export function useContentfulMeta({
    queryId,
    variables,
    options = { enabled: true },
}: UseContentfulMetaProps) {
    const { data, isLoading } = useContentful<
        SiteContentMetaDataResponse,
        ContentfulQueryVariables,
        ReturnType<typeof transformSiteContentMetaData>
    >(queryId, variables, {
        enabled: options.enabled,
        select: transformSiteContentMetaData,
    });

    return { metaData: data, isLoading };
}
